import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useSwitchStyles = (content: any) => makeStyles((theme: Theme) =>
	createStyles({
		root: {
			width: content ? '28px' : '74px',
			height: content? '17px' : '31px',
			padding: 0,
			border: `1px solid ${theme.palette.basic.lightGrey}`,
			borderRadius: 100,
			marginRight: content ? '10px' : 0,
		},
		switchBase: {
			padding: content ? 2 : 4,
			'&$checked': {
				'& + $track': {
					backgroundColor: theme.palette.primaryColor,
				},
			},
		},
		thumb: {
			color: theme.palette.mainLight,
			width:  content ? 11 : 21,
			height:  content ? 11 : 21,
			border: `1px solid ${theme.palette.basic.lightGrey}`,
		},
		track: {
			borderRadius: 100,
			backgroundColor: 'white',
			opacity: '1 !important',
			'&:after, &:before': {
				fontSize: 14,
				position: 'absolute',
				top: 5,
				fontWeight: 600,
				fontFamily: 'Open Sans',
			},
			'&:after': {
				content: content ? "" : "'Yes'",
				left: 7,
				color: theme.palette.mainLight,
			},
			'&:before': {
				content:  content ? "" : "'No'",
				right: 7,
				color: 'black',
			},
		},
		checked: {
			color: `${theme.palette.primaryColor} !important`,
			transform: content ? 'translateX(10px) !important' : 'translateX(42px) !important',
		},
	})
);
